import { render, staticRenderFns } from "./EditShapesDialog.vue?vue&type=template&id=687e476a&scoped=true&"
import script from "./EditShapesDialog.vue?vue&type=script&lang=ts&"
export * from "./EditShapesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditShapesDialog.vue?vue&type=style&index=0&id=687e476a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e476a",
  null
  
)

export default component.exports